export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('ScrollToSection', (navigateToSection) => {
        const section = document.getElementById(navigateToSection);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  },
};
